// External
import { gql } from "@apollo/client";

export const getMissingCategoriesForMigrationQuery = gql`
  query getMissingCategoriesForMigration(
    $input: MissingCategoriesForAcademicTermMigrationInput!
  ) {
    documentation {
      internalToolsData {
        progressReport {
          missingCategoriesForAcademicTermMigration(input: $input) {
            id
            subjectName
            gradeName
            categoryName
          }
        }
      }
    }
  }
`;

export const getAssociatedDataOfAcademicTermQuery = gql`
  query getAssociatedDataOfAcademicTerm(
    $input: AssociatedDataOfAcademicTermInput!
  ) {
    documentation {
      internalToolsData {
        progressReport {
          associatedDataOfAcademicTerm(input: $input) {
            id
            type
            name
            url
          }
        }
      }
    }
  }
`;
